import { format, roundToNearestMinutes } from 'date-fns';

import { ENGAGEMENT_COLORS } from '@client/enums';

export const generateEngagementDataset = (data, config) => {
  const colors = [...ENGAGEMENT_COLORS];

  Object.keys(data).forEach((day) => {
    const color = colors.shift();

    const dataset = {
      label: day,
      fill: false,
      lineTension: 0.1,
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      backgroundColor: [],
      pointBorderColor: 'rgba(0,0,0,.2)',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: []
    };

    Object.keys(data[day]).forEach((time) => {
      const total = data[day][time];

      if (total < 5) {
        dataset.backgroundColor.push(`${color}60`);
      } else if (total > 5 && total < 10) {
        dataset.backgroundColor.push(`${color}80`);
      } else {
        dataset.backgroundColor.push(`${color}90`);
      }

      dataset.data.push({
        x: time.replace(':00', ''),
        y: day,
        r: Math.ceil(total / 2)
      });
    });

    config.datasets.push(dataset);
  });

  return config;
};

export const generateEngagementDefinitions = (date, definitions) => {
  const time = format(roundToNearestMinutes(date, { nearestTo: 30 }), 'h:mmaa');
  const day = format(date, 'EEE')[0].toUpperCase() + format(date, 'EEE').substring(1);

  if (!definitions[day]) {
    definitions[day] = {};
  }

  if (!definitions[day][time]) {
    definitions[day][time] = 1;
  } else {
    definitions[day][time]++;
  }

  return definitions;
};
